import React from 'react'
import { Box, Typography } from '@material-ui/core'
import styled from 'styled-components'
import { Button } from '@paro.io/base-ui'

const ErrorBox = styled(Box)`
  background-color: white;
  height: 100vh;
  width: 100%;
  padding-bottom: 100;
`

const ParoLogo = styled.img`
  height: 28px;
  width: auto;
  padding: 0px 0px 18px 5px;
`

const Error = (props) => {
  const handleClick = () => {
    const { history } = props
    history.push('/registration')
  }
  return (
    <ErrorBox>
      <Box
        display="flex"
        alignContent="center"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        padding="100px 0px 36px 5px;"
      >
        <a href="https://paro.io/">
          <ParoLogo src="https://paro.ai/image/PARO_logo.png" alt={'Paro Logo'} />
        </a>
        <Typography variant="h6" gutterBottom>
          Oh no! Seems like something went wrong.
        </Typography>
        <Typography variant="body1" paragraph>
          Please click the refresh button so we can help re-direct you.
        </Typography>
        <Button
          color="primary"
          size="small"
          onClick={handleClick}
          label="Refresh Page"
        />
        
      </Box>
    </ErrorBox>
  )
}

export default Error
